$(document).ready(function () {
	$('.ttgNCECounter').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			setTimeout(function(){
				$('.ttgNCECounterNumber').each(function () {
					var $this = $(this);
					var countTo = '';

					if ($this.attr('data-live')) {
						countTo = $this.attr('data-live');
					} else {
						countTo = $this.attr('data-count');
					}

					$({countNum: $this.text()}).animate({
						countNum: countTo
					},
					{
						//duration: countTo * 10,
						duration: 4000,
						easing: 'linear',
						step: function () {
							$this.text(Math.floor(this.countNum));
						},
						complete: function () {
							$this.text(this.countNum);
						}

					});
				});
			}, 1000);
		}
	});
});

